export const types = {
  SET_MODE: 'SET_MODE',
  SET_LAST_LAUNCHED_DATE: 'SET_LAST_LAUNCHED_DATE',
};
